import { render, staticRenderFns } from "./recycleList.vue?vue&type=template&id=a84824cc&scoped=true"
import script from "./recycleList.vue?vue&type=script&lang=js"
export * from "./recycleList.vue?vue&type=script&lang=js"
import style0 from "./recycleList.vue?vue&type=style&index=0&id=a84824cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84824cc",
  null
  
)

export default component.exports